import { Typography } from '@mui/material'
import { Box, styled } from '@mui/system'
import PropTypes from 'prop-types'
import React from 'react'
import { useSelector } from 'react-redux'
import { addCommas, toFixedIfNull } from '../../../../helpers'
import { useDefaultComponentTools } from '../../../../hooks/useDefaultComponentTools'
import {
	selectAvailableMargin,
	selectTailDigitOfCurrency,
	selectTotalEquity,
	selectTotalPnl,
	selectUsedMargin
} from '../../../../store/redusers/positions/selectors'
import {
	selectBonusBalance,
	selectCashBalance,
	selectClosedPnl,
	selectTotalBalance,
	selectUserCurrency
} from '../../../../store/redusers/user/selectors'

export const DepositItemBody = styled(Box)(({theme}) => ({
	alignItems: 'center',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	width: '144px',
	[theme.breakpoints.down('xxxl')]: {
		minWidth: '125px'
	}
}))

function DepositItem({deposit}) {
	const { theme, mdUp} = useDefaultComponentTools()
	const userCurrency = useSelector(selectUserCurrency)
	const tailDigitOfCurrency = useSelector(selectTailDigitOfCurrency) || 2
	const isPnlTotal = deposit.id === 'pnlTotal'

	const selector = () => {
		if(isPnlTotal) return selectTotalPnl
		if(deposit.id === 'closedPnl') return selectClosedPnl
		if(deposit.id === 'balance') return selectTotalBalance
		if(deposit.id === 'availableMargin') return selectAvailableMargin
		if(deposit.id === 'equity') return selectTotalEquity
		if(deposit.id === 'usedMargin') return selectUsedMargin
		if(deposit.id === 'cashBalance') return selectCashBalance
		if(deposit.id === 'bonusBalance') return selectBonusBalance
	}
	const value = useSelector(selector()) || 0
	const color = isPnlTotal ? (value.totalPnl > 0 ? theme.palette.green : theme.palette.red) : ''

	return (
		<DepositItemBody>
			<Typography
				sx={{
					color: theme.palette.text.secondary,
					fontWeight: 400,
					mr: mdUp ? '10px' : 0
				}}
			>
				{deposit.label}
			</Typography>
			<Box sx={{display: 'flex'}}>
				<Typography variant='px13' sx={{color: color }}>
					{addCommas(toFixedIfNull(isPnlTotal ?
						value.totalPnl : value, tailDigitOfCurrency))}
				</Typography>
				<Typography  variant='px13' sx={{color: color , ml: 0.5}}>{userCurrency}</Typography>
			</Box>
		</DepositItemBody>
	)
}

DepositItem.propTypes = {
	deposit: PropTypes.object
}

export default DepositItem
